import styled from '@emotion/styled';
import CalendarIcon from 'src/assets/icons/CalendarIcon';

export const CalendarIconWrapper = styled(CalendarIcon, { label: 'CalendarIconWrapper' })`
    fill: #000;
    height: auto;
    margin-right: 8px;
`;


export const DateInputContainer = styled('div', { label: 'DateInputContainer' })`
    span[role='alert'] {
        display: none;
    }
`;
